export default __webpack_public_path__ + "assets/gamanza-logo.svg";